<template lang="pug">
    router-view
</template>

<script>
export default {
    
}
</script>

<style lang="scss">
.content{
    display: flex
}
.maincontent{
    min-width: 0px;
    min-height: 100vh;
    flex-flow: 1;
    display: flex;
    flex-direction: column;
}
</style>